/* LUVA pre-launch countdown (added 2026-10-04). Target comes from data-launch (epoch seconds). */
(function () {
  function pad(n) { return n < 10 ? '0' + n : String(n); }
  function tick() {
    var els = document.querySelectorAll('[data-luva-countdown]');
    if (!els.length) return false;
    var now = Date.now() / 1000;
    var live = false;
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var t = parseInt(el.getAttribute('data-launch'), 10);
      if (!t) { t = Date.parse(el.getAttribute('data-luva-countdown')) / 1000; }
      var left = Math.max(0, Math.floor(t - now));
      if (left <= 0) { el.setAttribute('data-done', ''); continue; }
      live = true;
      var d = Math.floor(left / 86400), h = Math.floor(left % 86400 / 3600), m = Math.floor(left % 3600 / 60), s = left % 60;
      var map = { d: String(d), h: pad(h), m: pad(m), s: pad(s) };
      var parts = el.querySelectorAll('[data-cd]');
      for (var j = 0; j < parts.length; j++) {
        var k = parts[j].getAttribute('data-cd');
        if (parts[j].textContent !== map[k]) parts[j].textContent = map[k];
      }
    }
    return live;
  }
  function start() {
    if (!tick()) return;
    var id = setInterval(function () { if (!tick()) clearInterval(id); }, 1000);
    document.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('[data-luva-notify]') : null;
      if (!a) return;
      var input = document.querySelector('.luva-foot__form input[type="email"]');
      if (!input) return;
      e.preventDefault();
      input.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(function () { try { input.focus({ preventScroll: true }); } catch (err) { input.focus(); } }, 400);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
